import React, { useEffect, useState } from 'react';
import httpService from "../../services/httpService";
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import PodcasterUserItem from './PodcasterUserItem';
import UserInfo from "./UserInfo";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from 'react-bootstrap/Modal';

const ClubUsers = ({ clubGuid }) => {
    const [loading, setLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);
    const [showUserModal, setShowUserModal] = useState(false);

    useEffect(() => {
        if (clubGuid) {
            fetchUsers();
        }
    }, [clubGuid]);

    const fetchUsers = () => {
        setLoading(true);
        setError(null);

        httpService.get(`/dash/club/${clubGuid}/users`)
            .then((res) => {
                console.log('Club users:', res.data);
                setUsers(res.data.data || []);
            })
            .catch((err) => {
                console.error('Error fetching users:', err);
                setError(err.response?.data?.message || "Error loading users");
            })
            .finally(() => setLoading(false));
    };

    const selectUser = (user) => {
        setSelectedUser(user);
        setShowUserModal(true);
    };

    const handleCloseUserModal = () => {
        setShowUserModal(false);
        setSelectedUser(null);
    };

    if (loading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className="mt-2">Loading users...</p>
            </div>
        );
    }

    if (error) {
        return (
            <Alert variant="danger">
                {error}
            </Alert>
        );
    }

    if (!users || users.length === 0) {
        return (
            <Alert variant="info">
                No users found for this podcast club.
            </Alert>
        );
    }

    const filteredUsers = users.filter((user) => {
        if (!searchQuery) return true;

        const query = searchQuery.toLowerCase();
        const firstName = user.user.first_name?.toLowerCase() || '';
        const lastName = user.user.last_name?.toLowerCase() || '';
        const email = user.user.email?.toLowerCase() || '';

        return firstName.includes(query) ||
               lastName.includes(query) ||
               email.includes(query);
    });

    return (
        <>
            <div className="pt-3 component-ClubUsers">
                <h6 className="mb-3">Club Members ({users.length})</h6>

                <Form.Group className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Search by name or email..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    {searchQuery && (
                        <Form.Text className="text-muted">
                            Showing {filteredUsers.length} of {users.length} members
                        </Form.Text>
                    )}
                </Form.Group>

                {filteredUsers.length === 0 ? (
                    <Alert variant="info">
                        No members found matching "{searchQuery}"
                    </Alert>
                ) : (
                    filteredUsers.map((user) => (
                        <PodcasterUserItem
                            key={user.id}
                            user={user.user}
                            selectUser={selectUser}
                        />
                    ))
                )}

                {/* User Info Modal */}
                <Modal
                    size="lg"
                    show={showUserModal}
                    onHide={handleCloseUserModal}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>User Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedUser && (
                            <UserInfo
                                userGuid={selectedUser.guid}
                                clubGuid={clubGuid}
                                context={{
                                    type: 'club',
                                    data: {}
                                }}
                            />
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="light" onClick={handleCloseUserModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>
    )
};

export default ClubUsers;